<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '端口管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  </zh-table-page>

</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "端口号",
          placeholder: "端口号",
          value: "portNumber",
        },
        {
          component: "zh-select",
          label: "服务器",
          placeholder: "服务器",
          value: "serverId",
          url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
         
        },
      ],
      api: {
        list: "postPortPage",
        delete: "deletePortDelete",
        add: "postPortSave",
        edit: "postPortUpdate",
        detail: "",
        tree: "",
      },
      table: {
        columns: [
          { label: "端口号", prop: "portNumber" },
          { label: "服务器", prop: "serverName" },
          { label: "是否被占用", prop: "occupancy", 
          scopeFun: (scope) => {
            if (scope.row.serverType === 1) {
              return '被占用';
            }
            return '未被占用'

          },
          },
          { label: "是否对内开启", prop: "openInternally", 
          scopeFun: (scope) => {
            if (scope.row.serverType === 1) {
              return '开启';
            }
            return '未开启'

          },
          },
          { label: "是否对外开启", prop: "openPublic", 
          scopeFun: (scope) => {
            if (scope.row.serverType === 1) {
              return '开启';
            }
            return '未开启'

          },
          },
        ],
        operations: [
          { label: "编辑" },
          // { label: "删除", type: "danger" },
        ],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "端口号",
            placeholder: "请输入端口号",
            value: "portNumber",
          },
          {
            component: "zh-select",
            label: "服务器",
            placeholder: "请选择服务器",
            value: "serverId",
            url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
          },
          {
            component: "zh-select",
            label: "是否被占用",
            placeholder: "请选择是否被占用",
            value: "occupancy",
            defaultValue:0,
            options:[
              {value:1,label:'被占用 '},
              {value:0,label:'未被占用 '},
            ],
          },
          {
            component: "zh-select",
            label: "是否对内开启",
            placeholder: "请选择是否对内开启",
            value: "openInternally",
            defaultValue:1,
            options:[
              {value:1,label:'开启 '},
              {value:0,label:'未开启 '},
            ],
          },
          {
            component: "zh-select",
            label: "是否对外开启",
            placeholder: "请选择是否对外开启",
            value: "openPublic",
            defaultValue:1,
            options:[
              {value:1,label:'开启 '},
              {value:0,label:'未开启 '},
            ],
          },
          
        ],
        dialogRules: {
          portNumber: [
            { required: true, message: "端口号不能为空", trigger: "blur" },
          ],
          serverId: [
            { required: true, message: "请选择服务器", trigger: "blur" },
          ],
          occupancy: [
            { required: true, message: "请选择是否被占用不能为空", trigger: "blur" },
          ],
          openInternally: [
            { required: true, message: "请选择是否对内开启不能为空", trigger: "blur" },
          ],
          openPublic: [
            { required: true, message: "请选择是否对外开启", trigger: "blur" },
          ],
        
         
        },
      },
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
       
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
        portNumber:Number(form.portNumber)
      }
    }

    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
    };
  },
});
</script>
